export enum EventWizardStep {
  STEP_1 = 1,
  STEP_2 = 2,
  STEP_3 = 3
}

export enum EventStatus {
  UPCOMING = 'Upcoming',
  LIVE = 'Live',
  FINISHED = 'Past',
  ARCHIVED = 'Archived'
}

export enum EventsListFlag {
  REGULAR_EVENT = 'regular_event'
}

export enum EventTimingStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

/** Hours behaviour for timing-exception add/edit form (exception API uses OPEN / DIFFERENTHOURS / CLOSED strings). */
export enum TimingExceptionHoursMode {
  CLOSED = 'CLOSED',
  DIFFERENTHOURS = 'DIFFERENTHOURS'
}
